import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a4caf35")

_pushScopeId("data-v-2a4caf35")
const _hoisted_1 = { class: "preferences" }
const _hoisted_2 = { class: "content_ls_margin" }
const _hoisted_3 = { class: "ls-slate-dark" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "content-wrapper" }
const _hoisted_8 = { class: "left-side" }
const _hoisted_9 = { class: "box" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h4", { class: "center mb-3" }, [
  /*#__PURE__*/_createTextVNode("Email Preferences "),
  /*#__PURE__*/_createVNode("span", { style: {"font-family":"var(--font-body-text)","font-weight":"400"} }, "(Optional)")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", null, "Please select one or more email preferences:", -1)
const _hoisted_12 = { class: "checkboxes" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "checkbox-button" }
const _hoisted_16 = { class: "checkbox-elmt" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createVNode("span", { class: "checkmark" })
], -1)
const _hoisted_18 = { class: "checkbox-text" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", {
  class: "mt-4 mb-4",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle mr-3" }),
  /*#__PURE__*/_createVNode("div", null, "Communications from the selected committees will be sent to your preferred email address.")
], -1)
const _hoisted_20 = { class: "right-side" }
const _hoisted_21 = { class: "box" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h4", { class: "center mb-3" }, [
  /*#__PURE__*/_createTextVNode("Areas of Interest "),
  /*#__PURE__*/_createVNode("span", { style: {"font-family":"var(--font-body-text)","font-weight":"400"} }, "(Optional)")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", null, "Please select the areas of law you are interested in:", -1)
const _hoisted_24 = { class: "checkboxes" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "checkbox-button" }
const _hoisted_28 = { class: "checkbox-elmt" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createVNode("span", { class: "checkmark" })
], -1)
const _hoisted_30 = { class: "checkbox-text" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", {
  class: "mt-4",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle mr-3" }),
  /*#__PURE__*/_createVNode("div", null, "This information will help us provide you with the most relevant content of interest to you.")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageHeader), 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.emailPreferencesList, (e) => {
                return (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("label", _hoisted_15, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": $event => (e.isSelected = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelCheckbox, e.isSelected]
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode("span", _hoisted_18, _toDisplayString(e.preferenceTypeDisplayName), 1)
                      ])
                    ])
                  ])
                ]))
              }), 256))
            ])
          ]),
          _hoisted_19
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.areaOfInterestsList, (a) => {
                return (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("label", _hoisted_27, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": $event => (a.isSelected = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelCheckbox, a.isSelected]
                      ]),
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode("span", _hoisted_30, _toDisplayString(a.name), 1)
                      ])
                    ])
                  ])
                ]))
              }), 256))
            ])
          ]),
          _hoisted_31
        ])
      ])
    ])
  ]))
})